// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: #53534c;
  text-align: center;
}

.Header {
  display: flex;
  flex-direction: column;
  max-height: 70px;
  padding-top: 15px;
  padding-bottom: 10px;
  background-color: #53534c;
}

.Body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  padding-bottom: 80px;
  background-color: #53534c;
  color: white;
}

.Footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100vw;
  background-color: #53534c;
  box-shadow: 0px 0px 18px white;
}

.Camera {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  max-width: 720px;
  background-color: #53534c;
}

.camera-container {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 720px;
  max-height: 720px;
  background-color: #53534c;
}

.camera-overlay {
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.text {
  max-width: 80vw;
  overflow-wrap: break-word;
  color: white;
  font-size: 16px;
}

.box {
  inline-size: 100vh;
  overflow-wrap: break-word;
}

.GoButton {
  background-color: #c98c3c;
  color: white;
  font-size: min(15vw, 60px);
  line-height: 320%;
  height: 50vw;
  max-height: 200px;
  width: 50vw;
  max-width: 200px;
  border: none;
  border-radius: 100px;
  margin-top: 50px;
  cursor: pointer;
  box-shadow: 5px 5px 10px rgb(49, 49, 49);
}

button {
  background-color: #c98c3c;
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 18px;
  cursor: pointer;
  box-shadow: 5px 5px 10px rgb(49, 49, 49);
}

.ButtonBox {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100vw;
  max-width: 100vw;
}

.NavButtonBox {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100vw;
  max-width: 100vw;
}

.ToggleBox {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: 100vw;
}

.MuiOutlinedInput-notchedOutline{
  border: 2px solid #c98c3c !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".App {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n  background-color: #53534c;\n  text-align: center;\n}\n\n.Header {\n  display: flex;\n  flex-direction: column;\n  max-height: 70px;\n  padding-top: 15px;\n  padding-bottom: 10px;\n  background-color: #53534c;\n}\n\n.Body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  padding-bottom: 80px;\n  background-color: #53534c;\n  color: white;\n}\n\n.Footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  bottom: 0px;\n  width: 100vw;\n  background-color: #53534c;\n  box-shadow: 0px 0px 18px white;\n}\n\n.Camera {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  max-width: 720px;\n  background-color: #53534c;\n}\n\n.camera-container {\n  position: relative;\n  width: fit-content;\n  max-width: 720px;\n  max-height: 720px;\n  background-color: #53534c;\n}\n\n.camera-overlay {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.text {\n  max-width: 80vw;\n  overflow-wrap: break-word;\n  color: white;\n  font-size: 16px;\n}\n\n.box {\n  inline-size: 100vh;\n  overflow-wrap: break-word;\n}\n\n.GoButton {\n  background-color: #c98c3c;\n  color: white;\n  font-size: min(15vw, 60px);\n  line-height: 320%;\n  height: 50vw;\n  max-height: 200px;\n  width: 50vw;\n  max-width: 200px;\n  border: none;\n  border-radius: 100px;\n  margin-top: 50px;\n  cursor: pointer;\n  box-shadow: 5px 5px 10px rgb(49, 49, 49);\n}\n\nbutton {\n  background-color: #c98c3c;\n  color: white;\n  font-size: 16px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 18px;\n  cursor: pointer;\n  box-shadow: 5px 5px 10px rgb(49, 49, 49);\n}\n\n.ButtonBox {\n  display: flex;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  width: 100vw;\n  max-width: 100vw;\n}\n\n.NavButtonBox {\n  display: flex;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  width: 100vw;\n  max-width: 100vw;\n}\n\n.ToggleBox {\n  display: flex;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  max-width: 100vw;\n}\n\n.MuiOutlinedInput-notchedOutline{\n  border: 2px solid #c98c3c !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
